import { PUBLIC_ROUTES } from 'app/constants';
import queryString from 'query-string';

export const locationHelpers = {
  getWindowLocationSearch: () => window.location.search,
  getWindowLocationPathname: () => window.location.pathname.split('/').pop(),
};

export const parseIsBackOffice = () => {
  const queryStringObject = queryString.parse(locationHelpers.getWindowLocationSearch()) || {};
  const accessToken = queryStringObject.accessToken || '';

  const path = locationHelpers.getWindowLocationPathname() || '';
  const isPublicRoute = (!path || PUBLIC_ROUTES.indexOf(path) > -1);

  const result = (!accessToken.trim() && !isPublicRoute);
  return result;
};

const isBackOffice = parseIsBackOffice();

export default isBackOffice;
